import { Form, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";
// import ContractInformationForm from "./components/ContractInformationForm";

import dayjs from "dayjs";
import "../../../../assets/styles/InterbankPlacement.css";
import StepsCard from "../../../../components/layouts/enhancement/StepsCard";
import StepsComponent from "../../../../components/layouts/enhancement/StepsComponent";
import CustomerEligibilityForm from "./components/CustomerEligibilityForm";
import Preview from "./components/Preview";
import ProductInformationForm from "./components/ProductInformationForm";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const EditWalletAccount = (props) => {
  const { userData } = props;
  const { session } = userData;
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const { state } = useLocation();

  const [useForm] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState("");
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [productData, setProductData] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({});
  const [currencyData, setCurrencyData] = useState([]);
  const [customerSegmentOptions, setCustomerSegmentOptions] = useState([]);
  const [statementCycleOptions, setStatementCycleOptions] = useState([]);
  const [transactionRestriction, setTransactionRestriction] = useState([]);
  const [filteredWalletProduct, setFilteredWalletProduct] = useState([]);
  const [kycLevelOptions, setKycLevelOptions] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    prodInfo: null,
    customerEligibility: null,
  });

  useEffect(() => {
    getWalletAccountById(state);
  }, []);

  const getWalletAccountById = (params) => {
    const url = `${apiConfig.WalletAccount}/${params.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        useForm.setFieldsValue({
          productId: objDetail?.productId,
          name: objDetail?.name,
          externalId: objDetail?.savingsAccountData?.externalId,
          currencyName: `${objDetail?.savingsAccountData?.currency?.name} (${objDetail?.savingsAccountData?.currency?.displaySymbol})`,
          decimalPlaces: objDetail?.savingsAccountData?.currency?.decimalPlaces,
          inMultiplesOf: objDetail?.savingsAccountData?.currency?.inMultiplesOf,
          kycLevel: objDetail?.kycLevel ?? objDetail?.kycLevel?.id,
          submittedOnDate: dayjs(
            objDetail?.savingsAccountData?.timeline?.submittedOnDate,
          ),
        });

        onChangeProduct(objDetail?.productId);
        setCustomerData(objDetail?.savingsAccountData);
        getCustomerDetailById(objDetail?.savingsAccountData);
        setCustomerParam(objDetail?.client);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    console.log("Selected Product ID:", productParam);

    const params = {
      clientId: customerInfo.id,
      productId: productParam,
    };

    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.walletsProductDataList.find(
          (data) => data.id === productParam,
        );
        let tempCurrency = objList?.currency;
        let tempCustomerSegmentOptions = [];
        let temptransactionRestriction = [];
        let tempStatementCycleOptions = [];
        let tempKycOptions = [];
        let tempProducts = [];

        useForm.setFieldsValue({
          currencyName: `${objList?.savingsProductData?.currency?.name} (${objList?.savingsProductData?.currency?.displaySymbol})`,
          decimalPlaces: objList?.savingsProductData?.currency?.decimalPlaces,
          inMultiplesOf: objList?.savingsProductData?.currency?.inMultiplesOf,
          kycLevel: objList?.kycLevel,
          customerSegment: objList?.customerSegments?.map((seg) => seg.id),
          transactionRestriction: objList?.transactionRestrictions?.map(
            (seg) => seg.id,
          ),
          statementCycle: objList?.statementCycles?.map((seg) => seg.id),
          // submittedOnDate: dayjs(
          //   BOM.FormatArrayDate(objList?.timeline?.submittedOnDate)
          // ),
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
        });

        res?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element?.savingsProductData?.name
              ? `${element?.savingsProductData?.name} (${element?.id})`
              : "",
          });
        });

        res?.walletsProductData.customerSegmentTypes?.forEach((element) => {
          tempCustomerSegmentOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData.transactionRestrictionTypes?.forEach(
          (element) => {
            temptransactionRestriction.push({
              value: element.id,
              label: element.value,
            });
          },
        );

        res?.walletsProductData.statementCycleTypes?.forEach((element) => {
          tempStatementCycleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData?.kycLevelTypes?.forEach((element) => {
          tempKycOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setProductData(tempProducts);
        setCurrencyData(tempCurrency);
        setKycLevelOptions(tempKycOptions);
        setCustomerSegmentOptions(tempCustomerSegmentOptions);
        setTransactionRestriction(temptransactionRestriction);
        setStatementCycleOptions(tempStatementCycleOptions);
        setIsProductSelected(true);
        setFilteredWalletProduct(objList);
        setIsLoading(false);
      }
    });
  };

  const getCustomerDetailById = (param) => {
    setIsLoading(true);
    const url = `${apiConfig.Clients}/${param.clientId}`;
    // const url = `${apiConfig.Clients}/${param.id}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentCustomer = {
          key: objDetail?.id,
          id: objDetail?.id,
          name: objDetail?.displayName ? objDetail?.displayName : "-",
          agentCode: objDetail?.agentMerchantData
            ? objDetail?.agentMerchantData?.agentCode
            : "-",
          agentType: objDetail?.agentMerchantData
            ? objDetail?.agentMerchantData?.agentType
            : "-",
          externalId: objDetail?.externalId ? objDetail?.externalId : "-",
          status: objDetail?.status ? objDetail?.status.value : "-",
          branch: objDetail?.officeName ? objDetail?.officeName : "-",
          staff: objDetail?.staffName ? objDetail?.staffName : "-",
          branchId: objDetail?.officeId ? objDetail?.officeId : "-",
          customerType: objDetail?.legalForm ? objDetail?.legalForm.value : "-",
        };

        setCustomerInfo(tempCurrentCustomer);

        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const onFinishProdInfoForm = (values) => {
    setFormData({ ...formData, prodInfo: values });
    setCurrent(current + 1);
  };

  const onFinishCustomerEligibilityForm = (values) => {
    setFormData({ ...formData, customerEligibility: values });
    setCurrent(current + 1);
  };

  const handleSubmit = (formValues) => {
    formValues = {
      ...formData.prodInfo,
      ...formData.customerEligibility,
    };

    formValues.submittedOnDate = BOM.DateTime(
      formValues.submittedOnDate,
      "only-date",
    );
    formValues.clientId = customerInfo.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.locale = "en";

    delete formValues.currencyName;
    delete formValues.decimalPlaces;
    delete formValues.inMultiplesOf;
    delete formValues.customerSearch;
    delete formValues.initiatedBy;

    const url = `${apiConfig.WalletAccount}/${state.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          setIsModalVisible(true);
          //STOP LOAD
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Your Wallet Account has been updated successfully.",
          );
          navigate("/wallet-account");
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/wallet-account");
          setIsLoading(false);
        },
      },
    );
  };

  const handleGoBack = () => {
    navigate("/wallet-account");
  };

  const stepsContent = [
    {
      title: "Product Information",
      component: (
        <ProductInformationForm
          searchParam={searchParam}
          customerInfo={customerInfo}
          showDetailsForm={showDetailsForm}
          onFinish={onFinishProdInfoForm}
          form={useForm}
          currencyData={currencyData}
          initialValues={formData.prodInfo}
          onChangeProduct={onChangeProduct}
          productData={productData}
          isProductSelected={isProductSelected}
          transactionRestriction={transactionRestriction}
          customerSegmentOptions={customerSegmentOptions}
          statementCycleOptions={statementCycleOptions}
          userData={userData}
          isCreateScreen={false}
        />
      ),
    },
    {
      title: "Customer Eligibility",
      component: (
        <CustomerEligibilityForm
          onFinish={onFinishCustomerEligibilityForm}
          current={current}
          setCurrent={setCurrent}
          initialValues={formData.customerEligibility}
          form={useForm}
          transactionRestriction={transactionRestriction}
          customerSegmentOptions={customerSegmentOptions}
          statementCycleOptions={statementCycleOptions}
          kycLevelOptions={kycLevelOptions}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <Preview
          formData={formData}
          // useCases={useCases}
          customerSegmentOptions={customerSegmentOptions}
          transactionRestriction={transactionRestriction}
          kycLevelOption={kycLevelOptions}
          statementCycleOptions={statementCycleOptions}
          currencyData={currencyData}
          customerInfo={customerInfo}
          templateProdDetail={templateProdDetail}
          productData={productData}
          filteredWalletProduct={filteredWalletProduct}
        />
      ),
    },
  ];

  const next = () => {
    const stepsUsingForm = [0, 1];

    if (stepsUsingForm.includes(current)) {
      useForm.submit();
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    const prevStep = current - 1;
    setCurrent(prevStep);

    // Remove the last completed step if going back
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  };

  return (
    <MainLayout pageItems={staticConfig.editWalletAccountBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.editWalletAccount}
        createPageTitle={labelConfig.updateWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={3}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            submitLabel="Update Account"
            onGoBack={handleGoBack}
          >
            {stepsContent[current].component}
          </StepsCard>
        </div>
      </Spin>
    </MainLayout>
  );
};

export default EditWalletAccount;
